import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import DataPair from 'shared/components/DataPair';
import LabeledContent from 'shared/components/LabeledContent';
import TextField from 'shared/components/TextField';
import { SafelistTerm } from 'shared/types/safelist';
import { closeModal } from 'services/modal/actions';

import { SafelistTermManager, SAFELIST_TERM_MANAGER_MODAL } from '../SafelistTermManager';

import { SafelistTermList } from './SafelistTermList';
import { SafelistDetailViewProps } from './types';

const SAFELIST_NAME_MAX_CHARACTERS = 120;

const StyledSafelistDetailViewContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledSafelistInfoContainer = styled.div`
  display: flex;
`;

const StyledSafelistInfoBox = styled.div`
  &:not(:last-child) {
    margin-right: 10.416rem;
  }
`;

const StyledLabeledContent = styled(LabeledContent)``;

const StyledTextField = styled(TextField)`
  width: 29.167rem;
  height: 3.67rem;
`;

const StyledSafelistTermList = styled(SafelistTermList)`
  flex: 1;
  min-height: 0;
  margin-top: 2.67rem;
`;

const SafelistDetailView = ({
  className,
  safelistName,
  terms,
  isNameEditable = true,
  onChangeName = () => {},
  onDeleteTerm = () => {},
  onAddTerms = () => {},
}: SafelistDetailViewProps) => {
  const dispatch = useDispatch();

  const handleTermNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isNameEditable) {
      onChangeName(event.target.value);
    }
  };

  const handleTermManagerSubmit = (terms: SafelistTerm[]) => {
    onAddTerms(terms);
    dispatch(closeModal(SAFELIST_TERM_MANAGER_MODAL));
  };

  return (
    <StyledSafelistDetailViewContainer className={className}>
      <StyledSafelistInfoContainer>
        <StyledSafelistInfoBox>
          <StyledLabeledContent label='Safelist Library Name'>
            <StyledTextField
              delay={250}
              isDisabled={!isNameEditable}
              onChange={handleTermNameChange}
              value={safelistName}
              maxLength={SAFELIST_NAME_MAX_CHARACTERS}
            />
          </StyledLabeledContent>
        </StyledSafelistInfoBox>
        <StyledSafelistInfoBox>
          <DataPair label='Items'>{terms?.length || 0}</DataPair>
        </StyledSafelistInfoBox>
      </StyledSafelistInfoContainer>
      <StyledSafelistTermList
        terms={terms}
        onDelete={onDeleteTerm}
      />
      <SafelistTermManager onSubmit={handleTermManagerSubmit} />
    </StyledSafelistDetailViewContainer>
  );
};

export { SafelistDetailView };
